<template>
  <router-link to="/">
    <img
      :height="height"
      :width="width"
      src="../assets/logo.svg"
    >
  </router-link>
</template>

<script>
export default {
  name: 'BaseLogo',
  props: {
    height: {
      type: Number,
      default: 36,
    },
    width: {
      type: Number,
      default: 36,
    },
  },
};
</script>
